export default __webpack_public_path__ + "static/media/gcsBucket.66c864b0.svg";